export default __webpack_public_path__ + "static/media/Headset-Settings.deb781b0.png";